<div
  class="bg-white dark:bg-transparent dark:bg-slate-900 h-full flex flex-col border-t border-gray-200 dark:border-gray-800">
  <form class="flex flex-col flex-grow p-6 w-full" [formGroup]="taskForm">
    <!--Title / Subject-->
    <div class="my-4">
      <mat-form-field class="w-full" [subscriptSizing]="'dynamic'" hideRequiredMarker="true">
        @if (isReplying) {
          <mat-label>Subject</mat-label>
        } @else {
          <mat-label>Title</mat-label>
        }
        <input matInput formControlName="task_label" cdkTextareaAutosize="true" [spellcheck]="true" />
        <mat-error class="pb-2" *ngIf="taskForm.get('task_label').hasError('required')">Value is required.</mat-error>
      </mat-form-field>
    </div>

    <!--Type-->
    <div class="my-1 -mt-2">
      <mat-form-field class="w-full" appearance="fill" hideRequiredMarker="true">
        <mat-label>Type</mat-label>
        <mat-select formControlName="task_type_id" required>
          <mat-option value="">Select a task type</mat-option>
          <mat-option *ngFor="let type of visibleTaskTypes" [value]="type.task_type_id">
            {{ type.task_type_label }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="taskForm.get('task_type_id')?.hasError('required')">Type is required</mat-error>
      </mat-form-field>
    </div>

    <div class="my-1 -mt-2">
      @if (qrAssociatedToTask?.quote_request_id) {
        <app-quote-request-task-association-view
          [quoteRequestTaskAssociation]="qrAssociatedToTask"
          (disassociateQuoteRequestEvent)="onDetachQuoteRequest()"></app-quote-request-task-association-view>
      } @else {
        <app-quote-request-search-input
          [label]="'Associate Quote Request'"
          [accountId]="selectedAccount?.account_id"
          (recordClickEvent)="appendQRRelatedEntity($event)"></app-quote-request-search-input>
      }
    </div>
    <!-- Assign To / Only exist if creating task from Account User Manage Interface-->
    <div class="w-full flex flex-col gap-1 my-1">
      <!--Created By To-->
      <span class="font-semibold">{{ isReplying ? 'Assigned To' : taskTypeCode === 'message' ? 'To' : 'Assign to' }} </span>
      <div class="w-full flex flex-col md:flex-row gap-1">

        @if (selectedAccount?.account_users || accountUsersList.length > 0) {
          <mat-form-field class="w-full md:w-6/12">
            <mat-label>Account Users</mat-label>
            <mat-select
              formControlName="account_user"
              multiple
              (selectionChange)="onAssigneeSelected($event, 'account_user')">
              <mat-option
                *ngFor="let accountUser of accountUsersList; trackBy: trackByFn"
                [value]="accountUser.account_user_id">
                {{ accountUser.account_user_first_name + ' ' + accountUser.account_user_last_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        }

        @if (taskTypeCode !== 'message') {
          <mat-form-field class="w-full md:w-6/12">
            <mat-label>Admins</mat-label>
            <mat-select formControlName="assign_to" multiple (selectionChange)="onAssigneeSelected($event)">
              <mat-option *ngFor="let user of adminUsers" [value]="user.admin_user_id">
                {{ user.user_first_name + ' ' + user.user_last_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="w-full md:w-6/12">
            <mat-label>Teams</mat-label>
            <mat-select formControlName="team" multiple (selectionChange)="onAssigneeSelected($event, 'team')">
              <mat-option *ngFor="let team of teams" [value]="team.team_id">
                {{ team.team_label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        }

      </div>
    </div>

    <!-- Due Date and Time (On the Same Line) -->
    <sbd-doug-frontend-task-date-time-picker
      [formGroup]="taskForm"
      (onDateTimePicked)="setDatePickedDateTime($event)"></sbd-doug-frontend-task-date-time-picker>

    <!--Description-->
    <div class="border-b pt-2 pb-4">
      <mat-label>Description</mat-label>
      <tiny-editor
        [editorOptions]="{ min_height: 400, max_height: 800, resize: true }"
        class="block"
        controlName="task_description"
        editorType="basic"></tiny-editor>
      <mat-error
        class="text-xs"
        *ngIf="taskForm.get('task_description')?.touched && taskForm.get('task_description')?.hasError('required')">
        Description is required
      </mat-error>
    </div>

    <!--File Uploader Area-->
    <div class="my-1">
      <button mat-raised-button class="flex items-center mt-4" (click)="openFileUploader()">
        <mat-icon>upload</mat-icon>
        <span class="ml-2 mr-1">Upload Files</span>
      </button>
    </div>
    <!-- Account User Reserved -->
    @if (queuedFiles?.length > 0) {
      <div class="w-full flex flex-col md:flex-row">
        <div class="my-1 w-2/3">
          <span class="my-2 font-semibold">Selected files</span>
          <div class="grid grid-cols-1 gap-2 items-center justify-start">
            <div *ngFor="let file of queuedFiles; let i = index">
              <div class="flex flex-row items-center">
                <button mat-icon-button class="cursor-pointer" color="warn" (click)="deleteFile(i)">
                  <mat-icon>delete</mat-icon>
                </button>
                <p class="truncate" rel="noopener noreferrer flex flex-row items-center">
                  <b>(Documentation)</b>
                  {{ file.name }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </form>

  @if (showFooter) {
  <sbd-doug-frontend-common-form-footer
    (cancel)="moveBackToParent()"
    (save)="submitForm()"
    [cancelText]="'Cancel'"
    [saveText]="saveButtonText"></sbd-doug-frontend-common-form-footer>
  }
</div>
